import Vue from 'vue';
import Vuex from 'vuex';
import { apiService } from '../services/apiService';
import { config } from '../config.js';
//import router from '../router/index.js';

Vue.use(Vuex);

//errorMessage, showError and showLoading can be set from component. But also gets set after/before a api-Call from store
//based on this, in app.vue ErrorNotifier or Loading-Component should be shown
import VueJwtDecode from 'vue-jwt-decode';
import VueCookies from 'vue-cookies';

export const store = new Vuex.Store({
  state: {
    showLoading: false,
    showError: false,
    errorMessage: '',
    navbar: null,
    token: VueCookies.get('shjwt') || null
  },
  //changed state directly
  mutations: {
    async hideError(state) {
      state.showError = false;
      state.errorMessage = '';
    },
    async showError(state, message) {
      state.showError = true;
      state.errorMessage = message;
    },
    async showLoading(state) {
      state.showLoading = true;
    },
    async hideLoading(state) {
      state.showLoading = false;
    },
    async dataReceived(state, response) {
      switch (response.type) {
        case 'Navbar':
          state.navbar = response.data;
      }
    },
    async loginSuccess(state, token) {
      VueCookies.set('shjwt', token,'1d','/',config.cookieDomain);
      state.token = token;
    },
    async logout(state) {
      VueCookies.remove('shjwt','/',config.cookieDomain);
      state.token = null;
    }
  },
  //actions getting called, implement business logic here if neeede
  actions: {
    async hideError({ commit }) {
      commit('hideError')
      return;
    },
    async trySSO({commit}){
      try {
        await commit('showLoading');
        const response = await apiService.trySSO();
        await commit('loginSuccess', response.token);
        return 200;
      } catch (error) {
        await commit('showError', error.message);
      } finally {
        await commit('hideLoading');
      }
    },
    async login({ commit }, payload) {
      try {
        await commit('showLoading');
        const response = await apiService.login(payload.username, payload.password);
        await commit('loginSuccess', response.token);
        return 200;
      } catch (error) {
        await commit('showError', error.message);
      } finally {
        await commit('hideLoading');
      }
    },
    async logout({ commit }) {
      await commit('logout');
      return;
    },
    async showError({ commit }, message) {
      await commit('showError', message);
      return;
    },
    async getNavbar({ commit }) {
      try {
        await commit('showLoading');
        const response = await apiService.getNavbar();
        let itStatus = response.data.find(x => x.description == "IT-Systemstatus");
        itStatus.pic = "ok_300_175.png";
        itStatus.description = "Keine Störungen bekannt";
        //get it-status and update navBar-text
        try {
          const itstatus = await apiService.getITStatus();
          if(itstatus.data && itstatus.data.length > 0) {
            itStatus.pic = "error_300_175.png";
            itStatus.description = "Aktuell liegen Störungen vor! Klicken Sie hier für nähere Infos.";
          }
        } catch {console.log("itstatus")}
        //success
        await commit('dataReceived', { type: 'Navbar', data: response.data });
      } catch (error) {
        await commit('showError', error.message);
      } finally {
        await commit('hideLoading');
      }
    },
    async getTKStatus() {
        const response = await apiService.getTKStatus();
        return response.status == 200 ? response.data.status : null;
    },
    async setTKStatus(ev,status) {
      const response = await apiService.setTKStatus(status);
      return response.status == 200 ? response.data.status : null;
  }
  },
  //used to get state, also used as "computed props"
  getters: {
    //function so getter isnt cached
    tokenNotGivenOrExpired: state => () => { return state.token == null || (Date.now() >= VueJwtDecode.decode(state.token).exp * 1000) },
    isLoggedInAsUser: state => {return state.token != null ? (Date.now() < VueJwtDecode.decode(state.token).exp * 1000) : false},
    userName: state => { return state.token !== null ? VueJwtDecode.decode(state.token).user.name : ''; },
    decodedJwt: state => { return state.token !== null ? VueJwtDecode.decode(state.token) : null;},
    links: state => {
      return state.navbar ? state.navbar : null;
    }
  }
});
